import React from "react";
import WebView from "./ViewItems/WebView";
import MobileView from "./ViewItems/MobileView";
import MultipleRecipientsDialog from "./MultipleRecipientsDialog";

const MessagesList = (props) => {
    const { handleCloseMultipleRecipientsDialog, toggleMultipleRecipients, multipleRecipientList, messages, handleOpenMultipleRecipientsDialog, deleteMessagePending, onDeleteMessage, currentUrl, getNameOfRecipient, getUserIdOfRecipient, getNameOfUsergroup, onChangeStatusMessage } = props;
    return (
        <>
            <div id="inb-c-main-messages" className="inb-c-listing off-canvas-content" data-off-canvas-content="" style={{minHeight: "840px"}}>
            {messages.map((message,index) => {
                return (
                    <>
                        <WebView
                            message={message}
                            index={index}
                            handleOpenMultipleRecipientsDialog={handleOpenMultipleRecipientsDialog}
                            deleteMessagePending={deleteMessagePending}
                            onDeleteMessage={onDeleteMessage}
                            currentUrl={currentUrl}
                            getNameOfRecipient={getNameOfRecipient}
                            getUserIdOfRecipient={getUserIdOfRecipient}
                            getNameOfUsergroup={getNameOfUsergroup}
                            onChangeStatusMessage={onChangeStatusMessage}
                        />
                        <MobileView
                            message={message}
                            index={index}
                            handleOpenMultipleRecipientsDialog={handleOpenMultipleRecipientsDialog}
                            deleteMessagePending={deleteMessagePending}
                            onDeleteMessage={onDeleteMessage}
                            currentUrl={currentUrl}
                            getNameOfRecipient={getNameOfRecipient}
                            getUserIdOfRecipient={getUserIdOfRecipient}
                            getNameOfUsergroup={getNameOfUsergroup}
                            onChangeStatusMessage={onChangeStatusMessage}
                        />
                            <MultipleRecipientsDialog
                                handleCloseMultipleRecipientsDialog = {handleCloseMultipleRecipientsDialog}
                                toggleMultipleRecipients = {toggleMultipleRecipients}
                                multipleRecipientList = {multipleRecipientList}
                            />
                    </>
                )
            })}
            </div>
        </>
    );
}
export default MessagesList;